import { useSelector } from 'react-redux';
import { getModulesSearchTerm } from 'EmailEditorUI/redux/selectors/selected';
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_QUERY_LENGTH = 25;
function truncateSearchQuery(str) {
  if (str.length <= MAX_QUERY_LENGTH) {
    return str;
  }
  return `${str.slice(0, MAX_QUERY_LENGTH)}...`;
}
export const EmptySearchResult = () => {
  const searchQuery = useSelector(getModulesSearchTerm);
  return /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
    title: "layoutBuilder.addPanel.emptyState.searchedModules.title",
    searchQuery: truncateSearchQuery(searchQuery)
  });
};